/**
 * Cart Quantity Size Intercept
 * Intercepts the plus button on quantity-input elements that have a size option.
 * Instead of incrementing quantity, opens the size-selector-modal to let the
 * customer choose a size for the additional item.
 */
(function() {
  'use strict';

  function initIntercept() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    cartDrawer.addEventListener('click', function(e) {
      var plusButton = e.target.closest('button[name="plus"]');
      if (!plusButton) return;

      var quantityInput = plusButton.closest('quantity-input[data-has-size-option]');
      if (!quantityInput) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var productHandle = quantityInput.dataset.productHandle;
      var variantId = quantityInput.dataset.variantId;
      var lineKey = quantityInput.dataset.lineKey;
      var propertiesJson = quantityInput.dataset.lineProperties;

      var properties = {};
      if (propertiesJson) {
        try { properties = JSON.parse(propertiesJson); } catch (err) {}
      }

      var modal = document.querySelector('size-selector-modal');
      if (modal) {
        modal.open({
          productHandle: productHandle,
          variantId: variantId,
          lineKey: lineKey,
          properties: properties
        });
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntercept);
  } else {
    initIntercept();
  }
})();
